import { navigateTabs } from "../lib/tabNavigation";
export type MobilePanel = "map" | "brief" | "layers";

interface Props {
  panel: MobilePanel;
  onChange: (p: MobilePanel) => void;
}

const TABS: { id: MobilePanel; label: string; sub: string }[] = [
  // The BRIEF sheet is the lens's left rail — on the default IOC lens that is
  // the CCTV wall and flood watch. Citizen reports live in the bottom issue
  // roll on every tab.
  { id: "brief",  label: "BRIEF",  sub: "cctv · flood" },
  { id: "map",    label: "MAP",    sub: "twin" },
  { id: "layers", label: "LAYERS", sub: "lens · news" },
];

/**
 * MobileNav — fixed bottom segmented control on phones.
 *  BRIEF opens the left rail as a full-height sheet.
 *  MAP   collapses both panels so the map is full-bleed.
 *  LAYERS opens the right rail (news + layer palette).
 */
export function MobileNav({ panel, onChange }: Props) {
  return (
    <nav className="mobile-nav" role="tablist" tabIndex={-1} onKeyDown={navigateTabs} aria-label="Dashboard panels">
      {TABS.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={panel === t.id}
          tabIndex={panel === t.id ? 0 : -1}
          className={`mobile-nav-btn ${panel === t.id ? "active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          <span className="mobile-nav-label mono">{t.label}</span>
          <span className="mobile-nav-sub">{t.sub}</span>
        </button>
      ))}
    </nav>
  );
}
